import {
  createSlice,
  PayloadAction,

} from "@reduxjs/toolkit";

import { fetchProjectsByUserId} from "./projectsList.actions";
import { Project } from "types";
import { StatusState } from "store/types";

interface ProjectsListState {
  data: Project[];
  statusState:StatusState;
  error: string | null;
}

const initialState: ProjectsListState = {
  data: [],
  statusState:StatusState.IDLE,
  error: null,
};

export const projectsListSlice = createSlice({
  name: "projectsList",
  initialState,
  reducers: {
    setProjectsList:(state,action:PayloadAction<Project[]>)=>{
      state.data = action.payload
    },
    resetProjectsListState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectsByUserId.pending, (state) => {
        state.statusState = StatusState.LOADING;
        state.error = null;
      })
      .addCase(fetchProjectsByUserId.fulfilled, (state) => {
        state.statusState = StatusState.SUCCEEDED;
      })
      .addCase(fetchProjectsByUserId.rejected, (state, action) => {
        state.statusState = StatusState.FAILED;
        state.error = action.payload as string;
      });
  },
});

export const { resetProjectsListState, setProjectsList } = projectsListSlice.actions;

const projectsListReducer = projectsListSlice.reducer
export default projectsListReducer;
